<ion-content class="ion-padding-horizontal text-center">
  <div class="app-content">
    <img class="my-8"
         src="assets/lmu-logo.jpg"
         alt="LMU"
         width="200" />

    <h1 class="text-xxl m-0 font-700 mb-4">Servus und Griaßdi!</h1>

    <div class="emoji-xl mb-8">👋</div>

    <p class="italic mb-8">
      Schön, dass du uns bei der<br>Erforschung der Dialekte in Bayern<br>behilflich sein möchtest!
    </p>

    <strong>Wie möchtest du fortfahren?</strong>

    <app-auth-form />
  </div>
</ion-content>
